import React from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '@alphapoint/apex-web/lib/components/common/Modal/Modal';
import APLabelWithText from '@alphapoint/apex-web/lib/components/common/APLabelWithText';
import { getBEMClasses } from '@alphapoint/apex-web/lib/helpers/cssClassesHelper';
import { formatNumberToLocale } from '@alphapoint/apex-web/lib/helpers/numberFormatter';
import { convertIncrementToIntDecimalPlaces } from '@alphapoint/apex-web/lib/helpers/decimalPlaces/decimalPlacesHelper';

import '@alphapoint/apex-web/lib/components/ConfirmOrderModal/ConfirmOrderModalComponent.css';

const bemClasses = getBEMClasses('confirm-order-modal');

const ConfirmOrderModalComponent = (props) => {
  const { t } = useTranslation('order');

  const {
    formData,
    isConfirmModalOpen,
    dismissConfirmModal,
    confirmReport,
    metaData,
    orderFee,
    resetForm,
    priceIncrement,
    quantityIncrement,
    clearForm,
    setInstrument,
    selectedInstrumentId,
  } = props;

  const handleSubmit = () => {
    setInstrument({
      selectedInstrumentId: selectedInstrumentId,
      instrumentId: formData.selectedInstrumentId,
    });
    clearForm();
    formData.fee = orderFee;
    if (formData.orderType == 'Limit Order') {
      formData.limitPrice = metaData.minmaxLimitValue;
    }

    confirmReport(formData);
    resetForm();
  };

  const items = [
    {
      label: t('Order Type'),
      text: formData.orderType,
    },
    {
      label: t('Quantity'),
      text:
        formatNumberToLocale(formData.quantity, convertIncrementToIntDecimalPlaces(quantityIncrement)) +
        ` ${metaData.Product1Symbol}`,
    },
    {
      label: t('Price'),
      text:
        formatNumberToLocale(metaData.marketPrice, convertIncrementToIntDecimalPlaces(priceIncrement)) +
        ` ${metaData.Product2Symbol}`,
    },
    {
      label: t('Fee'),
      text: `${formatNumberToLocale(orderFee.OrderFee, orderFee.product)} ${orderFee.product}`,
    },
    {
      label: t('Value'),
      text: `${formatNumberToLocale(
        formData.quantity * metaData.marketPrice,
        convertIncrementToIntDecimalPlaces(priceIncrement),
      )} ${metaData.Product2Symbol}`,
    },
  ];

  return (
    <Modal
      isOpen={isConfirmModalOpen}
      title={t('Confirm Order')}
      close={dismissConfirmModal}
      footer={{
        buttonText: metaData.isBuySide ? t('Confirm Buy Order') : t('Confirm Sell Order'),
        buttonStyle: metaData.isBuySide ? 'additive' : 'subtractive',
        onClick: () => handleSubmit(),
      }}
      customClass={bemClasses(metaData.isBuySide ? 'bought' : 'sold')}>
      <div className={bemClasses()}>
        {items.map((item) => {
          return <APLabelWithText key={item.label} label={item.label} text={item.text} customClass={bemClasses()} />;
        })}
      </div>
    </Modal>
  );
};

export default ConfirmOrderModalComponent;
